import { isDev } from '../utils'

export const mainUrl = isDev ? '' : ''
